import { LoaderButton } from '@/common/components/loader-button';
import EstimatedPricing from './estimated-pricing';
import PDPStickyBar from './pdp-sticky-bar';
import * as gtag from '@/common/utils/gtags.client';
import { PackageSummary } from '@/catalog/hooks/use-package-summary';

interface ProceedToScheduleProps {
  isOrderable?: boolean;
  packageSummary?: PackageSummary;
  hasNoSelectedAgeCreditRange?: boolean;
  fullstoryContinueEventDelegate?: () => void;
  fullstoryOpenPlanPanelSavingsEventDelegate?: () => void;
  fullstoryOpenMobileStickyFooterSavingsEventDelegate?: () => void;
  continueButtonRef?: (node?: Element | null) => void;
  handleSavingsClick?: () => void;
}

export default function ProceedToSchedule({
  isOrderable,
  packageSummary,
  hasNoSelectedAgeCreditRange,
  fullstoryContinueEventDelegate,
  fullstoryOpenPlanPanelSavingsEventDelegate,
  fullstoryOpenMobileStickyFooterSavingsEventDelegate,
  continueButtonRef,
  handleSavingsClick: _handleSavingsClick,
}: ProceedToScheduleProps) {
  const handleSubmitEvent = () => {
    gtag.event('vehicle_details_continue');
    fullstoryContinueEventDelegate?.();
  };

  const handleMobileStickyFooterSavingsClick = () => {
    _handleSavingsClick?.();
    fullstoryOpenMobileStickyFooterSavingsEventDelegate?.();
  };

  const handlePlanPanelSavingsClick = () => {
    _handleSavingsClick?.();
    fullstoryOpenPlanPanelSavingsEventDelegate?.();
  };

  return (
    <>
      {/* Mobile (Sticky bar) */}
      {isOrderable ? (
        <PDPStickyBar
          packageSummary={packageSummary}
          hasNoSelectedAgeCreditRange={hasNoSelectedAgeCreditRange}
          fullstoryContinueEventDelegate={fullstoryContinueEventDelegate}
          handleSavingsClick={handleMobileStickyFooterSavingsClick}
        />
      ) : null}

      {/* Desktop */}
      <div className="hidden w-full flex-col lg:flex">
        {/* Estimated pricing */}
        {packageSummary ? (
          <EstimatedPricing
            estimatedMonthlyCostCopy={packageSummary.estimatedMonthlyCostCopy}
            estimatedMonthlySavingsCopy={packageSummary.estimatedSavingsCopy}
            className="hidden lg:flex"
            onClickDelegate={handlePlanPanelSavingsClick}
          />
        ) : null}

        {/* Continue button */}
        <LoaderButton
          ref={continueButtonRef}
          variant="primary"
          type="submit"
          name="intent"
          value="plan-with-insurance"
          className="hidden rounded-full hover:bg-flexcar-neutral20 lg:flex"
          disabled={isOrderable !== true}
          onClick={handleSubmitEvent}
        >
          Continue
        </LoaderButton>
      </div>
    </>
  );
}
